export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ20.0e4a08ff.mp3";